import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import DrawDetail from "../Modal/DrawDetail";
import FreezeDetail from "../Modal/FreezeDetail";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { toast } from "react-toastify";
import {
  getMembersInfo,
  selectMembersInfo,
  selectMembersInfoLoading,
  selectMemberInfo,
  getDrawDetail,
  getFreezeDetail,
  getDocumentFile,
  selectDocumentFile,
  downloadCdnFile,
  downloadReportFile,
} from "../../../state/ducks/member/index";
import {
  fileUploadService,
  sendDocumentsForReviewService,
  getGuarantorsService,
  addGuarantorService,
  deleteGuarantorService,
  getMemberDeliveryDocumentsService,
  saveDeliveryScopeSelectionService,
  saveServiceRecordService,
} from "../../../services/member.service"
import SalesDocumentUploadTab from "./SalesDocumentUploadTab";
import EminevimLoading from "../shared/EminevimLoading";
import AppCustomSelect from "../shared/AppCustomSelect";

class Expenses extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.salesDocumentTabRef = React.createRef();
    this.state = {
      cekilisTarihi: null,
      uye: "ÜYELİK BİLGİLERİM",
      currency: "₺",
      selectedmobilDokumanTurId: null,
      isShowLoading: false,
      loadingSubtext: "İşleminiz gerçekleştiriliyor, lütfen bekleyiniz.",
      guarantors: [],
      showAddGuarantorModal: false,
      showGuarantorCriteriaWarningModal: false,
      showDeleteGuarantorModal: false,
      selectedGuarantorId: null,
      guarantorForm: {
        adi: "",
        soyadi: "",
        vatandaslikNo: "",
        gsm: "",
        dogumTarihi: ""
      },
      deliveryDocuments: null,
      deliveryDocumentsLoading: false,
      selectedOrgTypeId: "",
      selectedServiceRecordId: "",
      isChangingDeliveryScope: false,
      isChangingServiceRecord: false,
      showDeliveryDocumentsInfoModal: false,
      showDeliveryScopeConfirmModal: false,
      showServiceRecordGuarantorWarningModal: false,
      isShowGuarantors: false,
      isMemberTabsLoading: true,
      showSalesDocumentsTab: true,
    };
  }


  // Dosya seçilince çalışır
  handleFileChange = async (event) => {
    const file = event.target.files[0];
    const { selectedmobilDokumanTurId } = this.state;

    if (!file || !selectedmobilDokumanTurId) return;

    const { match } = this.props;
    var memberId = match?.params?.id;

    const formData = new FormData();
    formData.append("File", file);
    formData.append("MobilDokumanTurId", selectedmobilDokumanTurId);
    formData.append("MemberId", memberId);

    // FormData içeriğini görmek için:
    for (let pair of formData.entries()) {
      console.log(pair[0], ":", pair[1]);
    }

    this.showPageLoading("Dosyanız yükleniyor, lütfen bekleyiniz.");
    fileUploadService(formData).then((result) => {
      this.hidePageLoading();
      console.log(result);
      if (result.success) {
        const { match } = this.props;
        var id = match?.params?.id;
        this.loadDeliveryDocuments(id);
        toast.success("Dosya yüklendi");

      } else {
        toast.error(result.message);
      }
    });

  };

  // “Yükle” tıklanınca file input'u tetikler
  handleUploadClick = (mobilDokumanTurId, e) => {
    e.preventDefault();
    this.setState({ selectedmobilDokumanTurId: mobilDokumanTurId }, () => {
      try {
        this.fileInputRef.current.click();
      } catch (error) {

      }
    });
  };

  componentDidMount() {
    const { match } = this.props;

    var id = match?.params?.id;
    this.props.getMembersInfo(id);

    let result = this.props.member.info.filter((item) => {
      return item.id.toString() === id;
    });

    if (result != null && result[0] != null) {
      this.setState({ uye: result[0] });
      this.setState({
        currency: result[0].orgTurId === 3 ? "XAU" : "₺",
      });
    }
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.match?.params?.id;
    const nextId = this.props.match?.params?.id;

    if (prevProps.membersInfoLoading && !this.props.membersInfoLoading) {
      this.setState({ isMemberTabsLoading: false });
    }

    if (prevId !== nextId && nextId) {
      this.setState({ isMemberTabsLoading: true });
      this.props.getMembersInfo(nextId);

      const result = this.props.member.info.filter((item) => {
        return item.id.toString() === nextId;
      });

      if (result != null && result[0] != null) {
        this.setState({
          uye: result[0],
          currency: result[0].orgTurId === 3 ? "XAU" : "₺",
          showSalesDocumentsTab: true,
        });
      }
    }
  }

  showPageLoading = (loadingSubtext = "İşleminiz gerçekleştiriliyor, lütfen bekleyiniz.") => {
    this.setState({ isShowLoading: true, loadingSubtext });
  };

  hidePageLoading = () => {
    this.setState({ isShowLoading: false });
  };

  parseApiResult = (result) => {
    if (typeof result === "string") {
      try {
        return JSON.parse(result);
      } catch (error) {
        return null;
      }
    }

    return result;
  };

  normalizePhone = (value) => {
    let digits = (value || "").replace(/\D/g, "");
    if (digits.startsWith("90")) {
      digits = digits.slice(2);
    }
    digits = digits.replace(/^0+/, "");
    return digits.substring(0, 10);
  };

  formatPhone = (value) => {
    const digits = this.normalizePhone(value);
    const first = digits.slice(0, 3);
    const second = digits.slice(3, 6);
    const third = digits.slice(6, 8);
    const fourth = digits.slice(8, 10);
    return [first, second, third, fourth].filter(Boolean).join(" ");
  };

  formatDateInput = (value) => {
    const digits = (value || "").replace(/\D/g, "").slice(0, 8);
    const day = digits.slice(0, 2);
    const month = digits.slice(2, 4);
    const year = digits.slice(4, 8);

    if (digits.length <= 2) return day;
    if (digits.length <= 4) return `${day}/${month}`;
    return `${day}/${month}/${year}`;
  };

  convertDisplayDateToIso = (value) => {
    const match = (value || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) return "";

    const [, dd, mm, yyyy] = match;
    const date = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
    if (
      Number.isNaN(date.getTime()) ||
      date.getFullYear() !== Number(yyyy) ||
      date.getMonth() + 1 !== Number(mm) ||
      date.getDate() !== Number(dd)
    ) {
      return "";
    }

    return `${yyyy}-${mm}-${dd}`;
  };

  isFutureDisplayDate = (value) => {
    const isoDate = this.convertDisplayDateToIso(value);
    if (!isoDate) return false;

    const selectedDate = new Date(`${isoDate}T00:00:00`);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selectedDate > today;
  };

  loadGuarantors = () => {
    const { match } = this.props;
    const uyelikId = Number(match?.params?.id) || 0;

    getGuarantorsService(uyelikId).then((result) => {
      const parsedResult = this.parseApiResult(result);
      const guarantors = parsedResult?.data || [];
      this.setState({ guarantors });
    }).catch(() => {
      this.setState({ guarantors: [] });
    });
  };

  getDeliveryDocumentsInfoHtml = (deliveryDocuments) => {
    return deliveryDocuments?.bilgilendirmeHtml || deliveryDocuments?.BilgilendirmeHtml || "";
  };

  openDeliveryDocumentsInfoModal = () => {
    this.setState({ showDeliveryDocumentsInfoModal: true });
  };

  closeDeliveryDocumentsInfoModal = () => {
    this.setState({ showDeliveryDocumentsInfoModal: false });
  };

  loadDeliveryDocuments = (memberId, showInfoModal = false) => {
    const id = memberId || this.props.match?.params?.id;
    if (!id) return;

    this.setState({ deliveryDocumentsLoading: true });
    getMemberDeliveryDocumentsService(id).then((result) => {
      const parsedResult = this.parseApiResult(result);
      if (parsedResult?.success) {
        const data = parsedResult.data;
        const bilgilendirmeHtml = this.getDeliveryDocumentsInfoHtml(data);
        this.setState({
          deliveryDocuments: data,
          deliveryDocumentsLoading: false,
          selectedOrgTypeId: data?.secilenOrgId ? String(data.secilenOrgId) : "",
          selectedServiceRecordId: data?.secilenHizmetTurId ? String(data.secilenHizmetTurId) : "",
          isChangingDeliveryScope: false,
          isChangingServiceRecord: false,
          showDeliveryDocumentsInfoModal: showInfoModal && !!bilgilendirmeHtml && data?.secilenOrgId === 2,
          isShowGuarantors: data.kefilEkleyebilir
        });
        if (data?.ekranTuru === 3) {
          this.loadGuarantors();
        }
      } else {
        this.setState({ deliveryDocumentsLoading: false });
        toast.error(parsedResult?.message || "Dokümanlar yüklenemedi");
      }
    }).catch(() => {
      this.setState({ deliveryDocumentsLoading: false });
      toast.error("Dokümanlar yüklenemedi");
    });
  };

  handleDeliveryDocumentsTabClick = () => {
    this.setState({ isChangingDeliveryScope: false, isChangingServiceRecord: false });
    this.loadDeliveryDocuments(undefined, true);
  };

  handleSalesDocumentsTabClick = () => {
    const salesDocumentTab = this.salesDocumentTabRef.current;
    if (salesDocumentTab) {
      salesDocumentTab.loadRequests();
    }
  };

  handleSalesDocumentsListLoaded = ({ isActive }) => {
    if (isActive === false) {
      this.setState({ showSalesDocumentsTab: false });
    }
  };

  openDeliveryDocumentsInfo = () => {
    const bilgilendirmeHtml = this.getDeliveryDocumentsInfoHtml(this.state.deliveryDocuments);
    if (bilgilendirmeHtml) {
      this.openDeliveryDocumentsInfoModal();
      return;
    }

    this.loadDeliveryDocuments(undefined, true);
  };

  handleDeliveryDocumentsInfoClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.openDeliveryDocumentsInfo();
  };

  openChangeDeliveryScope = () => {
    const { deliveryDocuments } = this.state;
    this.setState({
      isChangingDeliveryScope: true,
      selectedOrgTypeId: deliveryDocuments?.secilenOrgId ? String(deliveryDocuments.secilenOrgId) : ""
    });
  };

  cancelChangeDeliveryScope = () => {
    const { deliveryDocuments } = this.state;
    this.setState({
      isChangingDeliveryScope: false,
      selectedOrgTypeId: deliveryDocuments?.secilenOrgId ? String(deliveryDocuments.secilenOrgId) : ""
    });
  };

  handleSaveDeliveryScopeClick = () => {
    const { selectedOrgTypeId, isChangingDeliveryScope } = this.state;

    if (!selectedOrgTypeId) {
      toast.error("Lütfen teslimat kapsamını seçiniz");
      return;
    }

    if (isChangingDeliveryScope) {
      this.setState({ showDeliveryScopeConfirmModal: true });
      return;
    }

    this.saveDeliveryScopeSelection();
  };

  closeDeliveryScopeConfirmModal = () => {
    this.setState({ showDeliveryScopeConfirmModal: false });
  };

  confirmSaveDeliveryScopeSelection = () => {
    this.setState({ showDeliveryScopeConfirmModal: false }, () => {
      this.saveDeliveryScopeSelection();
    });
  };

  saveDeliveryScopeSelection = () => {
    const { match } = this.props;
    const memberId = match?.params?.id;
    const { selectedOrgTypeId } = this.state;

    if (!selectedOrgTypeId) {
      toast.error("Lütfen teslimat kapsamını seçiniz");
      return;
    }

    this.showPageLoading();
    saveDeliveryScopeSelectionService(memberId, selectedOrgTypeId).then((result) => {
      const parsedResult = this.parseApiResult(result);
      this.hidePageLoading();
      if (parsedResult?.success) {
        toast.success("Teslimat kapsamı kaydedildi");
        this.loadDeliveryDocuments(memberId);
      } else {
        toast.error(parsedResult?.message || "Kayıt yapılamadı");
      }
    }).catch(() => {
      this.hidePageLoading();
      toast.error("Kayıt yapılamadı");
    });
  };

  openChangeServiceRecord = () => {
    const { deliveryDocuments } = this.state;
    this.setState({
      isChangingServiceRecord: true,
      selectedServiceRecordId: deliveryDocuments?.secilenHizmetTurId
        ? String(deliveryDocuments.secilenHizmetTurId)
        : "",
    });
  };

  cancelChangeServiceRecord = () => {
    const { deliveryDocuments } = this.state;
    this.setState({
      isChangingServiceRecord: false,
      selectedServiceRecordId: deliveryDocuments?.secilenHizmetTurId
        ? String(deliveryDocuments.secilenHizmetTurId)
        : "",
    });
  };

  handleSaveServiceRecordClick = () => {
    const { selectedServiceRecordId } = this.state;

    if (!selectedServiceRecordId) {
      toast.error("Lütfen hizmet dökümü türünü seçiniz");
      return;
    }

    this.saveServiceRecordSelection();
  };

  shouldShowServiceRecordGuarantorWarning = (serviceRecordId) => {
    return serviceRecordId === "1" || serviceRecordId === "2";
  };

  closeServiceRecordGuarantorWarningModal = () => {
    this.setState({ showServiceRecordGuarantorWarningModal: false });
  };

  saveServiceRecordSelection = () => {
    const { match } = this.props;
    const memberId = match?.params?.id;
    const { selectedServiceRecordId } = this.state;

    if (!selectedServiceRecordId) {
      toast.error("Lütfen hizmet dökümü türünü seçiniz");
      return;
    }

    this.setState({ isShowLoading: true });
    saveServiceRecordService(memberId, selectedServiceRecordId).then((result) => {
      const parsedResult = this.parseApiResult(result);
      const showGuarantorWarning = this.shouldShowServiceRecordGuarantorWarning(selectedServiceRecordId);

      this.setState({ isShowLoading: false });
      if (parsedResult?.success) {
        toast.success(parsedResult?.message || "Hizmet dökümü kaydedildi");
        if (showGuarantorWarning) {
          this.setState({ showServiceRecordGuarantorWarningModal: true });
        }
        this.loadDeliveryDocuments(memberId);
      } else {
        toast.error(parsedResult?.message || "Kayıt yapılamadı");
      }
    }).catch(() => {
      this.setState({ isShowLoading: false });
      toast.error("Kayıt yapılamadı");
    });
  };

  renderServiceRecordGuarantorWarningModal = () => {
    const { showServiceRecordGuarantorWarningModal } = this.state;

    if (!showServiceRecordGuarantorWarningModal) return null;

    return (
      <>
        <div className="modal fade show" style={{ display: "block", zIndex: 1004 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content border-0 shadow" style={{ borderRadius: 14, overflow: "hidden" }}>
              <div
                className="modal-header border-0"
                style={{ backgroundColor: "#fff7ed", color: "#7c2d12", borderBottom: "1px solid #fed7aa" }}
              >
                <h5 className="modal-title mb-0">Bilgilendirme</h5>
                <button type="button" className="close" onClick={this.closeServiceRecordGuarantorWarningModal}>
                  <span style={{ color: "#9a3412" }}>&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ backgroundColor: "#fffbeb", padding: 24, fontSize: "11pt", color: "#585858" }}>
                Gelir belgesi yüklenmediği için devam edebilmeniz adına kefil eklemeniz gerekmektedir.
              </div>
              <div className="modal-footer border-0 justify-content-center" style={{ backgroundColor: "#fffbeb", paddingTop: 8, paddingBottom: 20 }}>
                <button
                  type="button"
                  className="btn btn-light border px-4"
                  style={{ borderRadius: 10, backgroundColor: "#339f53", color: "white" }}
                  onClick={this.closeServiceRecordGuarantorWarningModal}
                >
                  ANLADIM
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1003 }}></div>
      </>
    );
  };

  renderDeliveryDocumentsInfoModal = () => {
    const { showDeliveryDocumentsInfoModal, deliveryDocuments } = this.state;
    const bilgilendirmeHtml = this.getDeliveryDocumentsInfoHtml(deliveryDocuments);

    if (!showDeliveryDocumentsInfoModal || !bilgilendirmeHtml) return null;

    return (
      <>
        <div className="modal fade show" style={{ display: "block", zIndex: 1003 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div className="modal-content border-0 shadow" style={{ borderRadius: 14, overflow: "hidden" }}>
              <div
                className="modal-header border-0"
                style={{ backgroundColor: "#f8fafc", color: "#585858", borderBottom: "1px solid #e2e8f0" }}
              >
                <h5 className="modal-title mb-0">Muvafakatname ve Nüfus Kayıt Örneğini Nasıl Alırım ?</h5>
                <button type="button" className="close" onClick={this.closeDeliveryDocumentsInfoModal}>
                  <span style={{ color: "#585858" }}>&times;</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{ backgroundColor: "#ffffff", padding: 24, maxHeight: "70vh", overflowY: "auto" }}
                dangerouslySetInnerHTML={{ __html: bilgilendirmeHtml }}
              />
              <div className="modal-footer border-0 justify-content-center" style={{ backgroundColor: "#f8fafc", paddingTop: 8, paddingBottom: 20 }}>
                <button
                  type="button"
                  className="btn btn-light border px-4"
                  style={{ borderRadius: 10, backgroundColor: "#339f53", color: "white" }}
                  onClick={this.closeDeliveryDocumentsInfoModal}
                >
                  ANLADIM
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1002 }}></div>
      </>
    );
  };

  renderDeliveryStatusAlert = (deliveryDocument) => {
    if (!deliveryDocument?.durumMesaj) return null;

    return (
      <div
        className="t-icSssCerceve"
        style={{
          border: `1px solid ${deliveryDocument.durumRenkKodu}`,
          backgroundColor: `${deliveryDocument.durumRenkKodu}54`,
          padding: "8px 30px"
        }}
      >
        <div className="row no-gutters">
          <div className="col-12">
            <strong style={{ color: deliveryDocument.durumRenkKodu, fontSize: "11pt" }}>DURUM</strong>
            <br />
          </div>
          <div className="col" style={{ fontSize: "10pt", color: "#585858", textAlign: "left" }}>
            {deliveryDocument.durumMesaj}
          </div>
        </div>
      </div>
    );
  };

  renderDeliveryScopeSelection = () => {
    const { deliveryDocuments, selectedOrgTypeId, isChangingDeliveryScope } = this.state;

    return (
      <>
        {this.renderDeliveryStatusAlert(deliveryDocuments)}
        <div className="row no-gutters mt-4">
          <div className="col-md-12">
            <label><strong style={{ fontSize: "11pt" }}>Teslimat Kapsamını Seçiniz</strong></label>
            <label style={{ fontSize: "11pt" }}>Teslimat dosyanızın doğru şekilde oluşturulabilmesi için teslimata konu olacak varlık türünü seçiniz. Seçiminize göre talep edilecek belge ve değerlendirme süreçleri farklılık gösterebilir.</label>
            <div className="t-appCustomSelectField mt-2">
              <AppCustomSelect
                id="deliveryOrgType"
                value={selectedOrgTypeId}
                placeholder="Seçiniz"
                options={[
                  { value: "", label: "Seçiniz" },
                  { value: "1", label: "Araç" },
                  { value: "2", label: "Ev/İş Yeri" },
                ]}
                onChange={(nextValue) => this.setState({ selectedOrgTypeId: nextValue })}
              />
            </div>
          </div>
        </div>
        <div className="col-12 d-flex justify-content-center pb-3 mt-4">
          {isChangingDeliveryScope && (
            <button
              className="btn btn-light border px-4 mr-2"
              type="button"
              onClick={this.cancelChangeDeliveryScope}
            >
              Vazgeç
            </button>
          )}
          <button className="t-icButtonYesil" onClick={this.handleSaveDeliveryScopeClick} type="button">
            <span>Kaydet</span>
            <i className="t-icon-arrow-right2" />
          </button>
        </div>
      </>
    );
  };

  renderServiceRecordSelection = () => {
    const { deliveryDocuments, selectedServiceRecordId, isChangingServiceRecord } = this.state;

    return (
      <>
        {this.renderDeliveryStatusAlert(deliveryDocuments)}
        <div className="row no-gutters mt-4">
          <div className="col-md-12">
            <label><strong style={{ fontSize: "11pt" }}>Hizmet Dökümü Seçimi</strong></label>
            <label style={{ fontSize: "11pt" }}>
              Araç teslimat dosyanızın doğru şekilde oluşturulabilmesi için hizmet dökümü türünü seçiniz.
              Seçiminize göre talep edilecek belge ve değerlendirme süreçleri farklılık gösterebilir.
            </label>
            <div className="t-appCustomSelectField mt-2">
              <AppCustomSelect
                id="deliveryServiceRecord"
                value={selectedServiceRecordId}
                placeholder="Seçiniz"
                options={[
                  { value: "", label: "Seçiniz" },
                  { value: "1", label: "4A" },
                  { value: "2", label: "4B" },
                  { value: "3", label: "4C" },
                ]}
                onChange={(nextValue) => this.setState({ selectedServiceRecordId: nextValue })}
              />
            </div>
          </div>
        </div>
        <div className="col-12 d-flex justify-content-center pb-3 mt-4">
          {isChangingServiceRecord && (
            <button
              className="btn btn-light border px-4 mr-2"
              type="button"
              onClick={this.cancelChangeServiceRecord}
            >
              Vazgeç
            </button>
          )}
          <button className="t-icButtonYesil" onClick={this.handleSaveServiceRecordClick} type="button">
            <span>Kaydet</span>
            <i className="t-icon-arrow-right2" />
          </button>
        </div>
      </>
    );
  };

  renderDeliveryDocumentsLoading = () => (
    <EminevimLoading
      compact
      subtext="Teslimat doküman bilgileriniz hazırlanıyor, lütfen bekleyiniz."
    />
  );

  renderDeliveryDocumentsContent = () => {
    const { deliveryDocuments, guarantors, isChangingDeliveryScope, isChangingServiceRecord } = this.state;

    if (isChangingDeliveryScope) {
      return this.renderDeliveryScopeSelection();
    }

    if (isChangingServiceRecord) {
      return this.renderServiceRecordSelection();
    }

    return (
      <>
        {this.renderDeliveryStatusAlert(deliveryDocuments)}

        {deliveryDocuments?.secilenOrgAdi && (
          <div className="t-deliveryScopeBar">
            <div className="t-deliveryScopeBar-content">
              <div className="t-deliveryScopeBar-info">
                <i
                  className={deliveryDocuments.secilenOrgId === 1 ? "t-icon-truck1" : "t-icon-home1"}
                  aria-hidden="true"
                />
                <span className="t-deliveryScopeBar-label">Seçilen Teslimat Kapsamı</span>
                <span className="t-deliveryScopeBar-value">{deliveryDocuments.secilenOrgAdi}</span>
              </div>
              {deliveryDocuments?.teslimatKapsamiDegistirebilirMi && (
                <button
                  className="t-icButtonYesil"
                  type="button"
                  onClick={this.openChangeDeliveryScope}
                >
                  <span style={{ fontSize: "11pt" }}>Teslimat Kapsamını Değiştir</span>
                </button>
              )}
            </div>
          </div>
        )}

        {deliveryDocuments?.secilenOrgId === 1 && deliveryDocuments?.secilenHizmetTurAdi && (
          <div className="t-deliveryScopeBar">
            <div className="t-deliveryScopeBar-content">
              <div className="t-deliveryScopeBar-info">
                <i className="t-icon-document-alt-stroke" aria-hidden="true" />
                <span className="t-deliveryScopeBar-label">Seçilen Hizmet Dökümü Türü</span>
                <span className="t-deliveryScopeBar-value">{deliveryDocuments.secilenHizmetTurAdi}</span>
              </div>
              {deliveryDocuments?.hizmetTuruDegistirebilirMi && (
                <button
                  className="t-icButtonYesil"
                  type="button"
                  onClick={this.openChangeServiceRecord}
                >
                  <span style={{ fontSize: "11pt" }}>Hizmet Dökümü Türünü Değiştir</span>
                </button>
              )}
            </div>
          </div>
        )}

        {this.state.isShowGuarantors && (
          <>
            <div
              role="button"
              tabIndex={0}
              className="t-guarantorAddBox"
              onClick={this.openAddGuarantorModal}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  this.openAddGuarantorModal();
                }
              }}
            >
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  backgroundColor: "#e8f5e9",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "12px",
                }}
              >
                <i className="t-icon-user-plus" style={{ fontSize: "28px", color: "#0c9908" }} />
              </div>
              <div
                style={{
                  fontSize: "14pt",
                  fontWeight: "bold",
                  color: "#0c9908",
                  letterSpacing: "0.5px",
                  marginBottom: "8px",
                }}
              >
                KEFİL EKLE
              </div>
              <div style={{ fontSize: "11pt", color: "#6b7a90" }}>
                Kefil bilgilerini ekleyerek zorunlu dokümanları yüklemeye başlayın.
              </div>
            </div>

            <div className="t-deliverySectionCard">
              <strong className="t-deliverySectionTitle">Kefil Listesi</strong>

              <table className="table table-sm t-tablo t-guarantorList-table mt-3 mb-0">
                <thead>
                  <tr>
                    <th scope="col">Ad Soyad</th>
                    <th scope="col">TC No</th>
                    <th scope="col">Telefon</th>
                    <th scope="col">Doğum Tarihi</th>
                    <th scope="col" className="text-right">İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {guarantors && guarantors.length > 0 ? guarantors.map((item, index) => (
                    <tr key={item.id || item.tckn || index}>
                      <td data-label="Ad Soyad">{item.adSoyad}</td>
                      <td data-label="TC No">{item.tckn}</td>
                      <td data-label="Telefon">{this.formatPhone(item.gsm)}</td>
                      <td data-label="Doğum Tarihi">{item.dogumTarihi ? new Date(item.dogumTarihi).toLocaleDateString("tr-TR") : "-"}</td>
                      <td data-label="İşlem" className="text-right t-guarantorList-action">
                        {item.isDeleted === true ? (
                          <span className="text-warning">Silme onayı bekliyor</span>
                        ) : (
                          <button
                            className="btn btn-sm btn-outline-danger"
                            type="button"
                            onClick={() => this.deleteGuarantor(item.id)}
                          >
                            Sil
                          </button>
                        )}
                      </td>
                    </tr>
                  )) : (
                    <tr className="t-guarantorList-empty">
                      <td colSpan={5}>Kefil kaydı bulunmuyor.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}

        <div className="t-deliverySectionCard">
          <strong className="t-deliverySectionTitle">Dokümanlar</strong>

          <table className="table table-sm t-tablo mt-3 mb-0">
            <thead>
              <tr>
                <th className="text-left" scope="col">Doküman</th>
                <th scope="col">Durum</th>
                <th scope="col">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {deliveryDocuments?.dokumanlar &&
                deliveryDocuments.dokumanlar.map((item, index) => {
                  return (
                    <tr className="t-policeler" key={index}>
                      <td className="text-left ">
                        {item.isForced ? <span style={{ color: "red" }} title="Zorunlu"><b>*</b>&nbsp;</span> : <span>&nbsp;&nbsp;</span>}
                        {item.mobilDokumanAdi}
                        <a
                          className="t-upload"
                          hidden={item.sablonRaporId == null || item.sablonRaporId == 0}
                          href="#sablonindir"
                          onClick={() => this.downloadReportFile(item.sablonRaporId, "Muvafakatname.pdf")}
                        > (Şablon İndir)</a>
                      </td>
                      <td style={{ color: item.musteriDokumanDurumRenkKodu }}>
                        {item.musteriDokumanDurumText}
                        {item.musteriDokumanDurum == 2 && (item.aciklama && item.aciklama?.trim() != "") ?
                          <i
                            className="fa fa-info-circle ml-1"
                            aria-hidden="true"
                            data-toggle="tooltip"
                            data-placement="right"
                            style={{ color: "#f93333" }}
                            title={item.aciklama}
                          ></i>
                          : <span></span>}
                      </td>
                      <td>
                        <input
                          type="file"
                          ref={this.fileInputRef}
                          style={{ display: "none" }}
                          accept="application/pdf,image/*"
                          onChange={this.handleFileChange}
                        />
                        <a
                          hidden={item.isShowUpload != true}
                          className="t-upload p-1"
                          href="#yukle"
                          onClick={(e) => this.handleUploadClick(item.mobilDokumanTurId, e)}
                        >{item.id > 0 && item.mobilDokumanHash != null ? "Değiştir" : "Yükle"}</a>
                        <a
                          hidden={item.isShowDownload != true}
                          className="t-upload p-1"
                          href="#indir"
                          onClick={() => this.downloadCdnFile(item.id, item.mobilDokumanDosyaAdi)}
                        >İndir</a>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <div className="col-12 d-flex justify-content-center pb-3 mt-4">
          <button className="t-icButtonYesil" onClick={this.sendDocumentsForReview} type="button">
            <span>İncelemeye Gönder</span>
            <i className="t-icon-arrow-right2" />
          </button>
        </div>
      </>
    );
  };

  openAddGuarantorModal = () => {
    this.setState({ showGuarantorCriteriaWarningModal: true });
  };

  closeGuarantorCriteriaWarningModal = () => {
    this.setState({ showGuarantorCriteriaWarningModal: false });
  };

  confirmGuarantorCriteriaWarning = () => {
    this.setState({
      showGuarantorCriteriaWarningModal: false,
      showAddGuarantorModal: true,
      guarantorForm: {
        adi: "",
        soyadi: "",
        vatandaslikNo: "",
        gsm: "",
        dogumTarihi: ""
      }
    });
  };

  closeAddGuarantorModal = () => {
    this.setState({ showAddGuarantorModal: false });
  };

  closeDeleteGuarantorModal = () => {
    this.setState({
      showDeleteGuarantorModal: false,
      selectedGuarantorId: null
    });
  };

  handleGuarantorInputChange = (field, value) => {
    this.setState((prevState) => ({
      guarantorForm: {
        ...prevState.guarantorForm,
        [field]: value
      }
    }));
  };

  addGuarantor = () => {
    const { match } = this.props;
    const uyelikId = Number(match?.params?.id) || 0;
    const { guarantorForm } = this.state;
    const adi = guarantorForm.adi?.trim();
    const soyadi = guarantorForm.soyadi?.trim();
    const vatandaslikNo = guarantorForm.vatandaslikNo?.replace(/\D/g, "");
    const gsm = this.normalizePhone(guarantorForm.gsm);
    const dogumTarihi = this.convertDisplayDateToIso(guarantorForm.dogumTarihi);

    if (!adi || !soyadi || !vatandaslikNo || !gsm || !guarantorForm.dogumTarihi) {
      toast.error("Lütfen tüm alanları doldurun");
      return;
    }

    if (!dogumTarihi) {
      toast.error("Doğum tarihi formatı gg/aa/yyyy olmalıdır");
      return;
    }

    if (this.isFutureDisplayDate(guarantorForm.dogumTarihi)) {
      toast.error("Doğum tarihi bugünden büyük olamaz");
      return;
    }

    if (vatandaslikNo.length !== 11) {
      toast.error("TC No 11 haneli olmalıdır");
      return;
    }

    if (!gsm.startsWith("5")) {
      toast.error("Telefon numarası 5 ile başlamalı ve başında 0 olmamalıdır");
      return;
    }


    if (gsm.length !== 10) {
      toast.error("Telefon numarası 10 haneli olmamalıdır");
      return;
    }

    this.showPageLoading();

    addGuarantorService({
      kartId: 0,
      uyelikId,
      adi,
      soyadi,
      vatandaslikNo,
      gsm,
      dogumTarihi
    }).then((result) => {
      const parsedResult = this.parseApiResult(result);
      this.hidePageLoading();

      if (parsedResult?.success) {
        this.closeAddGuarantorModal();
        this.loadGuarantors();
        this.loadDeliveryDocuments(uyelikId);
        toast.success("Kefil kaydedildi");
      } else {
        toast.error(parsedResult?.message || "Kefil kaydedilemedi");
      }
    }).catch(() => {
      this.hidePageLoading();
      toast.error("Kefil kaydedilemedi");
    });
  };

  deleteGuarantor = (guarantorId) => {
    if (!guarantorId) {
      toast.error("Silme işlemi için kefil kimliği bulunamadı");
      return;
    }

    this.setState({
      showDeleteGuarantorModal: true,
      selectedGuarantorId: guarantorId
    });
  };

  confirmDeleteGuarantor = () => {
    const { selectedGuarantorId } = this.state;

    if (!selectedGuarantorId) {
      this.closeDeleteGuarantorModal();
      toast.error("Silme işlemi için kefil kimliği bulunamadı");
      return;
    }

    this.closeDeleteGuarantorModal();

    const { match } = this.props;
    const uyelikId = Number(match?.params?.id) || 0;

    this.showPageLoading();
    deleteGuarantorService({
      kartId: 0,
      uyelikId,
      id: selectedGuarantorId
    }).then((result) => {
      const parsedResult = this.parseApiResult(result);
      this.hidePageLoading();
      if (parsedResult?.success) {
        this.loadGuarantors();
        this.loadDeliveryDocuments(uyelikId);
        toast.success("Kefil silme işleminiz onaya gönderildi.");
      } else {
        toast.error(parsedResult?.message || "Kefil silinemedi");
      }
    }).catch(() => {
      this.hidePageLoading();
      toast.error("Kefil silinemedi");
    });
  };

  sendDocumentsForReview = () => {
    this.showPageLoading("Dokümanlarınız incelemeye gönderiliyor, lütfen bekleyiniz.");
    const { match } = this.props;
    var memberId = Number(match?.params?.id) ?? 0;

    // const formData = new FormData();
    // formData.append("MemberId", memberId);
    var data = {
      "cardId": 0,
      memberId
    };
    sendDocumentsForReviewService(data).then((result) => {
      this.hidePageLoading();
      if (result.success) {
        this.loadDeliveryDocuments(memberId);
        toast.success("Dosyalar incelemeye gönderildi");

      } else {
        toast.error(result.message);
      }
    });
  }

  setDrawId = (drawId, cekilisTarihi) => {
    const { match } = this.props;
    var id = match?.params?.id;
    this.props.getDrawDetail(id, drawId);
    this.setState({ cekilisTarihi: cekilisTarihi });
  };

  getFreezeDetail = (source) => {
    const { match } = this.props;
    var id = match?.params?.id;
    this.props.getFreezeDetail(id, source);
  };

  getDocumentFile = (documentId, documentName) => {
    var ext = documentName.substr(documentName.lastIndexOf('.') + 1);
    this.props.getDocumentFile(documentId, ext, documentName);
  };

  downloadCdnFile = (id, documentName) => {
    const { match } = this.props;
    var memberId = match?.params?.id;
    var ext = documentName.substr(documentName.lastIndexOf('.') + 1);
    this.props.downloadCdnFile(id, memberId, ext, documentName);
  };

  downloadReportFile = (raporId, documentName) => {
    const { match } = this.props;
    var memberId = match?.params?.id;
    var ext = documentName.substr(documentName.lastIndexOf('.') + 1);
    this.props.downloadReportFile(memberId, raporId, ext, documentName);
  };

  getAcceptTypes = (documentTypes) => {
    const map = {
      pdf: "application/pdf",
      image: "image/*"
    };

    return documentTypes
      ?.map(type => map[type])
      .filter(Boolean)
      .join(",");
  };

  getMemberHeaderThemeClass = () => {
    const { orgTurId } = this.state.uye;

    if (orgTurId === 2) return "t-memberDetail-header--green";
    if (orgTurId === 3) return "t-memberDetail-header--orange";
    if (orgTurId === 1) return "t-memberDetail-header--blue";
    return "t-memberDetail-header--blue";
  };

  renderMemberHeaderIcon = () => {
    const { orgTurId } = this.state.uye;

    if (orgTurId === 2) {
      return <i className="t-icon-home1" aria-hidden="true" />;
    }

    if (orgTurId === 3) {
      return (
        <img
          src="/assets/img/svg/icon_kabe.svg"
          alt=""
          className="t-memberDetail-headerKabeIcon"
        />
      );
    }

    if (orgTurId === 1) {
      return <i className="t-icon-truck1" aria-hidden="true" />;
    }

    return null;
  };

  renderMemberDetailLoading = () => (
    <EminevimLoading
      compact
      className="t-memberDetailTabsLoading"
      subtext="Üyelik içerikleri hazırlanıyor, lütfen bekleyiniz."
    />
  );

  renderPageLoadingOverlay = () => {
    if (!this.state.isShowLoading) return null;

    return (
      <div className="t-memberDetail-processingOverlay">
        <EminevimLoading subtext={this.state.loadingSubtext} />
      </div>
    );
  };

  renderMemberHeader = () => {
    const { uye } = this.state;
    const showPlannedDeliveryDate = uye.kayitTuruId !== 10 && uye.kayitTuruId !== 11;

    return (
      <div className={`t-memberDetail-header ${this.getMemberHeaderThemeClass()}`}>
        <div className="t-memberDetail-headerMain">
          <Link
            to="/Home/MemberInfo"
            className="t-memberDetail-headerBack"
            title="Üyelik Listesine Dön"
            aria-label="Üyelik Listesine Dön"
          >
            <i className="t-icon-arrow-left2" aria-hidden="true" />
          </Link>

          <div className="t-memberDetail-headerIcon">
            {this.renderMemberHeaderIcon()}
          </div>

          <div className="t-memberDetail-headerContent">
            <h1 className="t-memberDetail-headerTitle">{uye.orgSis}</h1>
            <div className="t-memberDetail-headerBadges">
              <span className="t-memberDetail-headerBadge">
                Üye No :&nbsp;
                <NumberFormat
                  decimalSeparator={false}
                  thousandSeparator={"."}
                  value={uye.uyeNo}
                  displayType={"text"}
                />
              </span>
              <span className="t-memberDetail-headerBadge">
                {showPlannedDeliveryDate ? "Planlanan Teslimat Tarihi" : "Teslimat Tarihi"} : &nbsp;{uye.teslimTarihi}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderDeleteGuarantorModal = () => {
    const { showDeleteGuarantorModal } = this.state;

    if (!showDeleteGuarantorModal) return null;

    return ReactDOM.createPortal(
      <>
        <div className="modal fade show t-guarantorModal" style={{ display: "block", zIndex: 1002 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content t-guarantorModal-content border-0">
              <div className="t-guarantorModal-header">
                <div className="t-guarantorModal-header-content">
                  <div className="t-guarantorModal-icon">
                    <i className="t-icon-trash1" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="t-guarantorModal-title">Silme Onayı</h5>
                    <p className="t-guarantorModal-subtitle">Kefil kaydı silinecektir.</p>
                  </div>
                </div>
                <button type="button" className="t-guarantorModal-close" onClick={this.closeDeleteGuarantorModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="t-guarantorModal-confirmBody">
                <p>Kefil bilgilerini silmeyi onaylıyor musunuz?</p>
              </div>
              <div className="t-guarantorModal-footer">
                <button
                  type="button"
                  className="t-guarantorModal-cancel"
                  onClick={this.closeDeleteGuarantorModal}
                >
                  Vazgeç
                </button>
                <button
                  type="button"
                  className="t-guarantorModal-deleteBtn"
                  onClick={this.confirmDeleteGuarantor}
                >
                  Evet, Sil
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1001 }}></div>
      </>,
      document.body
    );
  };

  renderGuarantorCriteriaWarningModal = () => {
    const { showGuarantorCriteriaWarningModal } = this.state;

    if (!showGuarantorCriteriaWarningModal) return null;

    return ReactDOM.createPortal(
      <>
        <div className="modal fade show" style={{ display: "block", zIndex: 1002 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content border-0 shadow" style={{ borderRadius: 14, overflow: "hidden" }}>
              <div
                className="modal-header border-0"
                style={{ backgroundColor: "#fff7ed", color: "#7c2d12", borderBottom: "1px solid #fed7aa" }}
              >
                <h5 className="modal-title mb-0">Bilgilendirme</h5>
                <button type="button" className="close" onClick={this.closeGuarantorCriteriaWarningModal}>
                  <span style={{ color: "#9a3412" }}>&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ backgroundColor: "#fffbeb", padding: 24, fontSize: "11pt", color: "#585858", lineHeight: 1.6 }}>
                <p className="mb-3">
                  Kefil olarak eklenecek kişinin aktif olarak çalışıyor ve belgelenebilir düzenli gelire sahip olması gerekmektedir.
                </p>
                <p className="mb-3">
                  Emekli, çalışmayan veya işten ayrılmış kişiler kefil olarak kabul edilmemektedir. Uygun kriterleri taşımayan kefil eklenmesi, teslimat sürecinizin iptal edilmesine veya uzamasına neden olabilir.
                </p>
                <p className="mb-0">
                  Lütfen kefil bilgilerini bu kriterlere uygun şekilde giriniz.
                </p>
              </div>
              <div className="modal-footer border-0 justify-content-center" style={{ backgroundColor: "#fffbeb", paddingTop: 8, paddingBottom: 20 }}>
                <button
                  type="button"
                  className="btn btn-light border px-4"
                  style={{ borderRadius: 10, backgroundColor: "#339f53", color: "white" }}
                  onClick={this.confirmGuarantorCriteriaWarning}
                >
                  ANLADIM
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 1001 }}></div>
      </>,
      document.body
    );
  };

  renderAddGuarantorModal = () => {
    const { showAddGuarantorModal, guarantorForm } = this.state;

    if (!showAddGuarantorModal) return null;

    return ReactDOM.createPortal(
      <>
        <div className="modal fade show t-guarantorModal" style={{ display: "block", zIndex: 1000 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content t-guarantorModal-content border-0">
              <div className="t-guarantorModal-header">
                <div className="t-guarantorModal-header-content">
                  <div className="t-guarantorModal-icon">
                    <i className="t-icon-user-plus" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="t-guarantorModal-title">Kefil Ekle</h5>
                    <p className="t-guarantorModal-subtitle">Kefil bilgilerini eksiksiz doldurunuz.</p>
                  </div>
                </div>
                <button type="button" className="t-guarantorModal-close" onClick={this.closeAddGuarantorModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="t-guarantorModal-body">
                <div className="pb-1">
                  <span className="t-icInputTitle pl-3">Adı</span>
                </div>
                <div className="t-icInput mb-3">
                  <div>
                    <i className="t-icon-user1" />
                  </div>
                  <input
                    value={guarantorForm.adi}
                    placeholder="Adı"
                    onChange={(e) => this.handleGuarantorInputChange("adi", e.target.value)}
                  />
                  <div />
                </div>

                <div className="pb-1">
                  <span className="t-icInputTitle pl-3">Soyadı</span>
                </div>
                <div className="t-icInput mb-3">
                  <div>
                    <i className="t-icon-user1" />
                  </div>
                  <input
                    value={guarantorForm.soyadi}
                    placeholder="Soyadı"
                    onChange={(e) => this.handleGuarantorInputChange("soyadi", e.target.value)}
                  />
                  <div />
                </div>

                <div className="pb-1">
                  <span className="t-icInputTitle pl-3">TC No</span>
                </div>
                <div className="t-icInput mb-3">
                  <div>
                    <i className="t-icon-user1" />
                  </div>
                  <input
                    value={guarantorForm.vatandaslikNo}
                    maxLength={11}
                    placeholder="11 haneli TC No"
                    onChange={(e) => this.handleGuarantorInputChange("vatandaslikNo", e.target.value.replace(/\D/g, ""))}
                  />
                  <div />
                </div>

                <div className="pb-1">
                  <span className="t-icInputTitle pl-3">Telefon</span>
                </div>
                <div className="t-icInput mb-3">
                  <div>
                    <i className="t-icon-phone1" />
                  </div>
                  <input
                    value={this.formatPhone(guarantorForm.gsm)}
                    maxLength={13}
                    placeholder="5XX XXX XX XX"
                    onChange={(e) => this.handleGuarantorInputChange("gsm", e.target.value)}
                  />
                  <div />
                </div>

                <div className="pb-1">
                  <span className="t-icInputTitle pl-3">Doğum Tarihi</span>
                </div>
                <div className="t-icInput mb-0">
                  <div>
                    <i className="t-icon-calendar1" />
                  </div>
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength={10}
                    placeholder="gg/aa/yyyy"
                    value={guarantorForm.dogumTarihi}
                    onChange={(e) => {
                      const formattedValue = this.formatDateInput(e.target.value);
                      if (formattedValue.length === 10 && this.isFutureDisplayDate(formattedValue)) {
                        return;
                      }
                      this.handleGuarantorInputChange("dogumTarihi", formattedValue);
                    }}
                  />
                  <div />
                </div>
              </div>
              <div className="t-guarantorModal-footer">
                <button
                  type="button"
                  className="t-guarantorModal-cancel"
                  onClick={this.closeAddGuarantorModal}
                >
                  Vazgeç
                </button>
                <button
                  type="button"
                  className="t-icButtonYesil"
                  onClick={this.addGuarantor}
                >
                  <span>Kaydet</span>
                  <i className="t-icon-arrow-right2" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" style={{ zIndex: 999 }}></div>
      </>,
      document.body
    );
  };


  render() {
    const { members, membersInfoLoading } = this.props;
    const {
      showDeliveryScopeConfirmModal,
      deliveryDocuments,
      deliveryDocumentsLoading,
      isMemberTabsLoading,
    } = this.state;
    const showMemberTabsLoading = membersInfoLoading || isMemberTabsLoading;
    return (
      <>
        {this.renderPageLoadingOverlay()}

        <div className="" style={{ background: "white" }}>
          <div className="row" style={{ padding: "3%" }}>
            <div className="col-12">
              {/* KUTU 3  EV */}

              {/* <div className={
                this.state.uye.orgTurId === 2 ? (
                  "row no-gutters t-kutu t-yesilCizgi"

                ) : this.state.uye.orgTurId === 3 ? (
                  "row no-gutters t-kutu t-turuncuCizgi"

                ) : this.state.uye.orgTurId === 1 ? (
                  "row no-gutters t-kutu t-mavicizgi"

                ) :
                  ("")
              }> */}
                <div className="col backbottom">
                  {/* içerikler */}
                  {this.renderMemberHeader()}
                  {showMemberTabsLoading ? (
                    this.renderMemberDetailLoading()
                  ) : (
                    <>
                  {/* tablı Sistem */}
                  <nav>
                    <div
                      className="nav nav-pills nav-fill nav-justified t-tablar"
                      id="nav-tab"
                      role="tablist"
                    >
                      <a
                        className={
                          this.state.uye.kayitTuruId === 8
                            ? "nav-link"
                            : "nav-link active"
                        }
                        data-toggle="tab"
                        data-target="#odemeler"
                        hidden={this.state.uye.kayitTuruId === 8}
                      >
                        ÖDEMELER
                      </a>
                      <a
                        className={
                          this.state.uye.kayitTuruId !== 8
                            ? "nav-link"
                            : "nav-link active"
                        }
                        data-toggle="tab"
                        data-target="#iadeler"
                        hidden={this.state.uye.kayitTuruId !== 8}
                      >
                        İADELER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#masraflar"
                      >
                        MASRAFLAR
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#hareketler"

                      >
                        HAREKETLER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#taksiterteleme"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          this.state.uye.dondurulanAy === null ||
                          this.state.uye.dondurulanAy === 0
                        }
                      >
                        TAKSİT ERTELEME
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#cekilisler"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.draws === null ||
                          members?.draws?.length === 0
                        }
                      >
                        ÇEKİLİŞLER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#teslimat"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.deliveryStatements?.list === null ||
                          members?.deliveryStatements?.list.length === 0
                        }
                      >
                        TESLİMAT DOSYA
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#teslimatFinans"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.deliveryFinancialStatements?.list === null ||
                          members?.deliveryFinancialStatements?.list.length === 0
                        }
                      >
                        TESLİMAT FİNANS
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#policeler"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.documents === null ||
                          members?.documents?.length === 0
                        }
                      >
                        POLİÇELER
                      </a>
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        data-target="#customerDocuments"
                        hidden={
                          this.state.uye.kayitTuruId === 8 ||
                          members?.customerDocuments === null ||
                          members?.customerDocuments?.length === 0
                        }
                      >
                        DOKÜMANLAR
                      </a>
                      <a
                        className="nav-link align-items-center"
                        data-toggle="tab"
                        data-target="#deliveryDocuments"
                        onClick={this.handleDeliveryDocumentsTabClick}
                        hidden={
                          members?.isShowDeliveryDocumentsWeb === false
                        }
                      >
                        DOKÜMAN YÜKLE
                      </a>
                      <a
                        className="nav-link align-items-center t-salesDocTabLink"
                        data-toggle="tab"
                        data-target="#salesDocuments"
                        onClick={this.handleSalesDocumentsTabClick}
                        hidden={members?.isShowUploadSalesDocuments === false}
                      >
                        <span className="t-salesDocNewRibbon" aria-hidden="true">YENİ</span>
                        SATIŞ DOKÜMANI YÜKLE
                      </a>
                    </div>
                  </nav>
                  <div className="tab-content p-2" id="nav-tabContent">
                    {/* Ödemeler Tablosu */}
                    <div
                      className={
                        this.state.uye.kayitTuruId === 8
                          ? "tab-pane fade table-responsive show"
                          : "tab-pane fade table-responsive show active"
                      }
                      id="odemeler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Dönem</th>
                            <th scope="col">Tür</th>
                            <th scope="col">Vade Tarihi</th>
                            <th scope="col">Ödenen ({this.state.currency})</th>
                            <th scope="col">Kalan ({this.state.currency})</th>

                          </tr>
                        </thead>
                        <tbody>
                          {members?.memberPayments?.list &&
                            members.memberPayments.list.map((item) => {
                              let classTaksit = "";
                              if (item.tur !== "TAKSIT" && item.kalanTutar !== 0)
                                classTaksit += "taksit_tipler";
                              if (item.tur !== "TAKSIT" && item.kalanTutar === 0)
                                classTaksit += " taksit_biten-tipler";
                              if (item.kalanTutar === 0)
                                classTaksit += " t-odendi";
                              return (
                                <tr key={item.id} className={classTaksit}>
                                  <td>
                                    {item.tur !== "TAKSIT" ? (
                                      <i className="t-icon-star-full"></i>
                                    ) : (
                                      item.donem
                                    )}
                                  </td>
                                  <td>{item.tur}</td>
                                  <td>{item.vadeTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.kalanTutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col" colSpan={2} />
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.memberPayments?.tutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.memberPayments?.kalanTutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* İadeler*/}
                    <div
                      className={
                        this.state.uye.kayitTuruId !== 8
                          ? "tab-pane fade table-responsive show"
                          : "tab-pane fade table-responsive show active "
                      }
                      id="iadeler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Tür</th>
                            <th scope="col">Vade Tarihi</th>
                            <th scope="col">İade Edilen ({this.state.currency})</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.returns?.list &&
                            members.returns.list.map((item) => {
                              return (
                                <tr key={item.id} className="t-odendi">
                                  <td>{item.islemTipi}</td>
                                  <td>{item.vadeTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col" />
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.returns?.tutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                      <p
                        className="small font-italic text-muted"
                        hidden={
                          members?.returns?.dilekceTarihi === null ||
                          members?.returns?.dilekceTarihi === ""
                        }
                      >
                        {members?.returns?.dilekceTarihi}
                      </p>
                    </div>
                    {/* Masraflar*/}
                    <div className="tab-pane fade table-responsive" id="masraflar">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Tür</th>
                            <th scope="col">Vade Tarihi</th>
                            <th scope="col">Ödenen ({this.state.currency})</th>
                            <th scope="col">Kalan ({this.state.currency})</th>

                          </tr>
                        </thead>
                        <tbody>
                          {members?.expenses?.list &&
                            members.expenses.list.map((item, index) => {
                              return (
                                <tr
                                  key={item.tur + item.vadeTarihi + "_" + index}
                                  className={
                                    item.kalanTutar === 0 ? "t-odendi" : ""
                                  }
                                >
                                  <td>{item.tur}</td>
                                  <td>{item.vadeTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.kalanTutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col" />
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.expenses?.tutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.expenses?.kalanTutarToplam}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* Hareketler*/}
                    <div className="tab-pane fade table-responsive" id="hareketler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">İşlem Tarihi</th>
                            <th scope="col">İşlem Tutarı ({this.state.currency})</th>
                            <th scope="col">Açıklama</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.movements &&
                            members.movements.map((item) => {
                              return (
                                <tr key={item.id}>
                                  <td>{item.islemTarihi}</td>
                                  <td>
                                    <NumberFormat
                                      decimalSeparator={","}
                                      thousandSeparator={"."}
                                      value={item.tutar}
                                      displayType={"text"}
                                    />
                                  </td>
                                  <td>{item.aciklama}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {/*Taksit Erteleme*/}
                    <div className="tab-pane fade table-responsive" id="taksiterteleme">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Erteleme Sebebi</th>
                            <th scope="col">Ay</th>
                            <th scope="col">Detay</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.freeze?.list &&
                            members.freeze.list.map((item) => {
                              return (
                                <tr key={item.id} className="t-taksiterteleme">
                                  <td>{item.ertelenmeSebebi}</td>
                                  <td>{item.ay}</td>
                                  <td>
                                    <a
                                      href="#erteleme"
                                      onClick={() =>
                                        this.getFreezeDetail(item.kaynak)
                                      }

                                      data-toggle="modal"
                                      data-target="#ertelemeModalCenter"
                                    >
                                      Detay

                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                          <tr>
                            <th scope="col">Toplam</th>
                            <th>
                              <NumberFormat
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                value={members?.freeze?.toplamAy}
                                displayType={"text"}
                              />
                            </th>
                            <th scope="col" />
                          </tr>
                        </tbody>
                      </table>
                      <br>
                      </br>
                      <p className="small font-italic text-muted">
                        {members?.freeze?.aciklama}
                      </p>
                      <p className="small font-italic text-muted">
                        {members?.freeze?.temsilciBilgi}
                      </p>
                    </div>
                    {/* Çekilişler*/}
                    <div className="tab-pane fade table-responsive" id="cekilisler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th scope="col">Çekiliş Tarihi</th>
                            <th scope="col">Çekiliş Durumu</th>
                            <th scope="col" />
                          </tr>
                        </thead>
                        <tbody>
                          {members?.draws &&
                            members.draws.map((item) => {
                              return (
                                <tr
                                  key={item.id}
                                  className={
                                    item.cekilisYapildiMi == true && item.ciktiMi ? "t-kazandiniz" : "t-cikmadi"
                                  }
                                >
                                  <td>
                                    {new Date(
                                      item.cekilisTarihi
                                    ).toLocaleDateString()}
                                  </td>
                                  <td>
                                    {item.cekilisDurumu}
                                  </td>
                                  <td>
                                    <a
                                      href="#cekilis"
                                      hidden={item.cekilisYapildiMi == false}
                                      onClick={() =>
                                        this.setDrawId(item.id, item.cekilisTarihi)
                                      }
                                      data-toggle="modal"
                                      data-target="#cekilisModalCenter"

                                    >
                                      Detay

                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {/* Teslimat */}
                    <div className="tab-pane fade table-responsive" id="teslimat">
                      {/* Tamamlanma durumu için background divindeki width değeri ve yazının % cinsinden verilmesi gerekli*/}
                      <div className="row no-gutters">
                        <div className="col-12 py-2">
                          <div className="t-oran">
                            <div className="background"
                              style={{
                                width:
                                  members?.deliveryStatements?.tamamlanmaOrani +
                                  "%",
                              }}
                              aria-valuenow={
                                members?.deliveryStatements?.tamamlanmaOrani
                              }
                              aria-valuemin="0"
                              aria-valuemax="100" />
                            <span>
                              Tamamlanma durumu <strong className="px-2"> {members?.deliveryStatements?.tamamlanmaOrani} %{" "}</strong>

                            </span>

                          </div>


                        </div>
                        <div className="col-12 py-2">
                          <span style={{ fontSize: "initial" }}>
                            Yol haritasına ve gerekli evrak listesine ulaşmak için
                            <a

                              target="_blank"
                              href={
                                this.state.uye.orgTurId === 2
                                  ? process.env.PUBLIC_URL +
                                  "/assets/docs/evraklistesi-yolharitasi-konut 2_rgb.pdf"
                                  : process.env.PUBLIC_URL +
                                  "/assets/docs/evraklistesi-yolharitasi-otomobil 2_rgb.pdf"
                              }
                            >
                              <b> tıklayınız.</b>
                            </a>
                          </span>
                        </div>
                      </div>
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th className="text-left" scope="col">Adımlar</th>
                            <th scope="col">Durum</th>
                            <th scope="col">Tamamlanma Tarihi</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.deliveryStatements?.list &&
                            members.deliveryStatements.list.map((item) => {
                              return (
                                <tr
                                  key={item.id}
                                  className={item.isDurum ? "t-tamamlandi" : "t-eksik"}
                                >
                                  <td className="text-left">{item.isTuru}</td>
                                  <td>
                                    {item.isDurum ? (
                                      <i className="t-icon-check_circle_outline"></i>
                                    ) : (
                                      <i className="far fa-times-circle text-danger"></i>
                                    )}
                                  </td>
                                  <td>{item.tamamlanmaTarihi}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>


                    {/* Teslimat Finans*/}
                    <div className="tab-pane fade" id="teslimatFinans">
                      {/* Tamamlanma durumu için background divindeki width değeri ve yazının % cinsinden verilmesi gerekli*/}
                      <div className="row no-gutters">
                        <div className="col-12 py-2">
                          <div className="t-oran">
                            <div className="background"
                              style={{
                                width:
                                  members?.deliveryFinancialStatements?.tamamlanmaOrani +
                                  "%",
                              }}
                              aria-valuenow={
                                members?.deliveryFinancialStatements?.tamamlanmaOrani
                              }
                              aria-valuemin="0"
                              aria-valuemax="100" />
                            <span>
                              Tamamlanma durumu <strong className="px-2"> {members?.deliveryFinancialStatements?.tamamlanmaOrani} %{" "}</strong>

                            </span>

                          </div>


                        </div>
                        {/* <div className="col-12 py-2">
                        <span style={{ fontSize: "initial" }}>
                          Yol haritasına ve gerekli evrak listesine ulaşmak için
                          <a

                            target="_blank"
                            href={
                              this.state.uye.orgTurId === 2
                                ? process.env.PUBLIC_URL +
                                "/assets/docs/evraklistesi-yolharitasi-konut 2_rgb.pdf"
                                : process.env.PUBLIC_URL +
                                "/assets/docs/evraklistesi-yolharitasi-otomobil 2_rgb.pdf"
                            }
                          >
                            <b> tıklayınız.</b>
                          </a>
                        </span>
                      </div> */}
                      </div>

                      {members?.deliveryFinancialStatements?.list &&
                        members.deliveryFinancialStatements.list.map((item, index) => {
                          return (
                            <div key={"base_" + index}>
                              <div className="table-responsive" style={{ backgroundColor: "#efefef", padding: "4px", fontSize: "12pt", fontWeight: "600", width: "100%" }}>Teslimat Id : {item.teslimatKesintiId}</div>
                              <table className="table table-sm t-tablo">
                                <thead>
                                  <tr>
                                    <th className="text-left" scope="col">Adımlar</th>
                                    <th scope="col" width="150">Durum</th>
                                    <th scope="col" width="150">Tamamlanma Tarihi</th>
                                  </tr>
                                </thead>
                                <tbody>

                                  {item.list.map((item2) => {
                                    return (
                                      <tr
                                        key={item2.id}
                                        className={item2.isDurum ? "t-tamamlandi" : "t-eksik"}
                                      >
                                        <td className="text-left">{item2.isTuru}</td>
                                        <td>
                                          {item2.isDurum ? (
                                            <i className="t-icon-check_circle_outline"></i>
                                          ) : (
                                            <i className="far fa-times-circle text-danger"></i>
                                          )}
                                        </td>
                                        <td>{item2.isDurum ? item2.tamamlanmaTarihi : "-"}</td>
                                      </tr>
                                    );
                                  })}

                                </tbody>
                              </table>
                            </div>
                          );
                        })

                      }

                    </div>

                    {/* Poliçeler*/}
                    <div className="tab-pane fade table-responsive" id="policeler">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th className="text-left" scope="col">Adı</th>
                            <th scope="col">Türü</th>
                            <th scope="col">Eklenme Tarihi</th>
                            <th scope="col" >İndir</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.documents &&
                            members.documents.map((item) => {
                              return (
                                <tr key={item.id} className="t-policeler">
                                  <td className="text-left">{item.dosyaAdi}</td>
                                  <td>{item.dokumanTurAdi}</td>
                                  <td>{item.tarihText}</td>
                                  <td>
                                    <a
                                      href="#indir"
                                      onClick={() => this.getDocumentFile(item.id, item.dosyaAdi)}
                                    >
                                      <i className="t-icon-folder-download"></i> İndir
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}

                        </tbody>
                      </table>
                    </div>


                    {/* customerDocuments */}
                    <div className="tab-pane fade table-responsive" id="customerDocuments">
                      <table className="table table-sm t-tablo">
                        <thead>
                          <tr>
                            <th className="text-left" scope="col">Adı</th>
                            <th scope="col">Türü</th>
                            <th scope="col">Eklenme Tarihi</th>
                            <th scope="col" >İndir</th>
                          </tr>
                        </thead>
                        <tbody>
                          {members?.customerDocuments &&
                            members.customerDocuments.map((item) => {
                              return (
                                <tr key={item.id} className="t-policeler">
                                  <td className="text-left">{item.dosyaAdi}</td>
                                  <td>{item.dokumanTurAdi}</td>
                                  <td>{item.tarihText}</td>
                                  <td>
                                    <a
                                      href="#indir"
                                      onClick={() => this.getDocumentFile(item.id, item.dosyaAdi)}
                                    >
                                      <i className="t-icon-folder-download"></i> İndir
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}

                        </tbody>
                      </table>
                    </div>




                    {/* deliveryDocuments */}
                    <div className="tab-pane fade table-responsive mt-2" id="deliveryDocuments">
                      {deliveryDocumentsLoading && !deliveryDocuments ? (
                        this.renderDeliveryDocumentsLoading()
                      ) : deliveryDocuments ? (
                        <>
                          <div className="d-flex justify-content-end mb-2">
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              title="Muvafakatname ve Nüfus Kayıt Örneğini Nasıl Alırım ?"
                              onClick={this.openDeliveryDocumentsInfo}
                              hidden={deliveryDocuments.ekranTuru !== 3 || deliveryDocuments.secilenOrgId !== 2}
                            >
                              <i className="t-icon-info_outline mr-1" />
                              Muvafakatname ve Nüfus Kayıt Örneğini Nasıl Alırım ?
                            </button>
                          </div>
                          {deliveryDocuments.ekranTuru === 1 && this.renderDeliveryStatusAlert(deliveryDocuments)}
                          {deliveryDocuments.ekranTuru === 2 && this.renderDeliveryScopeSelection()}
                          {deliveryDocuments.ekranTuru === 4 && this.renderServiceRecordSelection()}
                          {deliveryDocuments.ekranTuru === 3 && this.renderDeliveryDocumentsContent()}
                        </>
                      ) : (
                        <div className="text-center p-4 text-muted">Doküman bilgileri yüklenmedi.</div>
                      )}
                    </div>

                    <div className="tab-pane fade table-responsive mt-2" id="salesDocuments">
                      <SalesDocumentUploadTab
                        ref={this.salesDocumentTabRef}
                        memberId={this.props.match?.params?.id}
                        onListLoaded={this.handleSalesDocumentsListLoaded}
                      />
                    </div>

                  </div>
                    </>
                  )}
                  {/* içerikler BİTTİ */}
                </div>
                <div className="col-auto renk" />
              {/* KUTU 2 BİTTİ */}
              <DrawDetail cekilisTarihi={this.state.cekilisTarihi}></DrawDetail>
              <FreezeDetail></FreezeDetail>

              {this.renderDeliveryDocumentsInfoModal()}

              {showDeliveryScopeConfirmModal && (
                <>
                  <div className="modal fade show" style={{ display: "block", zIndex: 1004 }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                      <div className="modal-content border-0 shadow" style={{ borderRadius: 14, overflow: "hidden" }}>
                        <div
                          className="modal-header border-0"
                          style={{ backgroundColor: "#fff7ed", color: "#7c2d12", borderBottom: "1px solid #fed7aa" }}
                        >
                          <h5 className="modal-title mb-0">Onay</h5>
                          <button type="button" className="close" onClick={this.closeDeliveryScopeConfirmModal}>
                            <span style={{ color: "#9a3412" }}>&times;</span>
                          </button>
                        </div>
                        <div className="modal-body" style={{ backgroundColor: "#fffbeb", padding: 24 }}>
                          Teslimat kapsamı değişikliği yaptığınızda şu ana kadar yüklenen dokümanlarınız ve kefil bilgileriniz silinecektir !
                        </div>
                        <div className="modal-footer border-0" style={{ backgroundColor: "#fffbeb", paddingTop: 8, paddingBottom: 20 }}>
                          <button
                            type="button"
                            className="btn btn-light border px-4"
                            style={{ borderRadius: 10 }}
                            onClick={this.closeDeliveryScopeConfirmModal}
                          >
                            Vazgeç
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger px-4"
                            style={{ borderRadius: 10 }}
                            onClick={this.confirmSaveDeliveryScopeSelection}
                          >
                            Evet, Onaylıyorum
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-backdrop fade show" style={{ zIndex: 1003 }}></div>
                </>
              )}

              {this.renderDeleteGuarantorModal()}
              {this.renderGuarantorCriteriaWarningModal()}
              {this.renderAddGuarantorModal()}
            </div>
          </div>
          {/* Duyurlar Baslık*/}
          {/* duyrular Bitti*/}
          <div className="row" style={{ height: 30 }} />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
    members: selectMembersInfo(state),
    membersInfoLoading: selectMembersInfoLoading(state),
    file: selectDocumentFile(state)
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMembersInfo: (memberId) => dispatch(getMembersInfo(memberId)),
  getDrawDetail: (memberId, drawId) =>
    dispatch(getDrawDetail(memberId, drawId)),
  getFreezeDetail: (memberId, sourceId) =>
    dispatch(getFreezeDetail(memberId, sourceId)),
  getDocumentFile: (documentId, ext, documentName) => dispatch(getDocumentFile(documentId, ext, documentName)),
  downloadCdnFile: (id, memberId, ext, documentName) => dispatch(downloadCdnFile(id, memberId, ext, documentName)),
  downloadReportFile: (uyelikId, raporId, ext, documentName) => dispatch(downloadReportFile(uyelikId, raporId, ext, documentName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Expenses);
